export const downloadReport = (blob: Blob, name: string) => {
	const href = URL.createObjectURL(blob as any)
	const anchor = Object.assign(document.createElement("a"), {
		href,
		style: "display: none",
		download: name,
	})
	document.body.appendChild(anchor)
	anchor.click()
	URL.revokeObjectURL(href)
	anchor.remove()
}
